import "../../../assets/css/material-dashboard.css";
// import "../../../assets/css/material-dashboard.css.map";
import "../../../assets/css/nucleo-icons.css";
import "../../../assets/css/nucleo-svg.css";
import "../../../assets/css/material-dashboard.min.css";
import MainLayout from "../../MainLayout";
import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import axios from "axios";
import { AppConfig } from "src/config/AppConfig";
import { Link, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { CategoryScale } from "chart.js";
import { BarChart } from "src/components/layout/BarChart";
// import { useAppDispatch } from "src/hooks/redux/hooks";
// import book from "../../../assets/img/icons/subject.svg"
// import staff from "../../../assets/img/icons/staff.svg"
// import student from "../../../assets/img/icons/student.svg"
import workers from "../../../assets/img/icons/workers.png";
import customers from "../../../assets/img/icons/icons8-customers-100.png";
import workers1 from "../../../assets/img/icons/icons8-workers-100.png";
import users1 from "../../../assets/img/icons/icons8-team-100.png";


Chart.register(CategoryScale);
interface GraphData {
    memberships: {
        months: string[]; // Array of month names (or placeholders).
        counts: number[]; // Array of counts corresponding to each month.
    };
    subscriptions: {
        months: string[]; // Array of month names (or placeholders).
        counts: number[]; // Array of counts corresponding to each month.
    };
    doorstepOrders: {
        months: string[]; // Array of month names (or placeholders).
        counts: number[]; // Array of counts corresponding to each month.
    }
}
interface IDashboardData {
    todayUsersCount: number;                   // Number of users created today
    todayWorkersCount: number;                 // Number of workers created today
    yesterdayUsersCount: number;               // Number of users created yesterday
    totalUsersCount: number;                   // Total number of users
    todayVerifiedUsers: number;
    todayNotVerifiedUsers: number;
    totalVerifiedUsers: number;
    totalNotVerifiedUsers: number;
    todayActivatedWorkers: number;
    todayInactiveWorkers: number;
    totalActivatedWorkers: number;
    totalInactiveWorkers: number;
    thisWeekUsersCount: number;                // Number of users created this week
    prevWeekUsersCount: number;                // Number of users created in the previous week
    dayPercentageChangeInUsers: number;        // Percentage change in users from yesterday to today
    weekPercentageChangeInUsers: number;       // Percentage change in users from last week to this week
    totalWorkerCount: number;                  // Total number of workers
    thisWeekWorkerCount: number;               // Number of workers created this week
    prevWeekWorkerCount: number;               // Number of workers created in the previous week
    weekPercentageChangeInWorker: number;      // Percentage change in workers from last week to this week
    dayPercentageChangeInWorker: number;       // Percentage change in workers from yesterday to today
    totalMembershipSales: number;              // Total membership sales amount
    totalSubscriptionSales: number;            // Total subscription sales amount
    monthPercentageChangeInMembership: number,
    monthPercentageChangeInSubscription: number,
    monthPercentageChangeInDoorstepOrders: number,
    totalSales: number;
    graph_data: GraphData;                     // Graph Data


}
interface IFristRow {
    no?: number;
    icon: string;
    title: string;
    totalValues: number;
    active: number;
    inActive: number;
    bg: string;
    sideBg?: string;
    bottomText: string;
    bottomPercent: number;
    link: string;
}
const DashboardPage = () => {
    const navigate = useNavigate()
    const chartBarsRef = useRef(null);
    const chartLineRef = useRef(null);
    const chartLineTasksRef = useRef(null);
    const [dashboardData, setDashboardData] = useState<IDashboardData>();
    const Token = Cookies.get('token');

    // useEffect(() => {
    //     if (chartBarsRef.current && chartLineRef.current && chartLineTasksRef.current) {
    //         const canvasBars = chartBarsRef?.current as HTMLCanvasElement;
    //         const canvasLine = chartLineRef?.current as HTMLCanvasElement;
    //         const canvasLineTasks = chartLineTasksRef?.current as HTMLCanvasElement;

    //         const ctxBars = canvasBars?.getContext("2d");
    //         const ctxLine = canvasLine?.getContext("2d");
    //         const ctxLineTasks = canvasLineTasks?.getContext("2d");


    //         if (ctxBars) {
    //             new Chart(ctxBars, {
    //                 type: "bar",
    //                 data: {
    //                     labels: ["January", "February", "March", "April", "May", "June", "July"],
    //                     datasets: [{
    //                         label: "Sales",
    //                         data: [65, 59, 80, 81, 56, 55, 40],
    //                         backgroundColor: 'rgba(255, 99, 132, 0.2)',
    //                         borderColor: 'rgba(255, 99, 132, 1)',
    //                         borderWidth: 1
    //                     }]
    //                 },
    //                 options: {
    //                     // Bar chart options
    //                 },
    //             });
    //         }
    //     }
    // }, []);


    useEffect(() => {
        // console.log(Token)
        const getDashboardData = async () => {
            await axios.get(`${AppConfig.DEV_SERVER}/dashboard`, {
                headers: {
                    "x-access-token": Token,

                }
            }).then((response) => {
                // console.log(response?.data);
                if (response?.data?.status_code === 200) {
                    setDashboardData(response?.data?.data)
                }
            }).catch((err: any) => {
                console.log(err);
            });
        };

        getDashboardData();

    }, [Token]);
    // console.log(Token)
    useEffect(() => {
        if (Token?.length === 0 || Token === undefined) {
            navigate("/admin/sign-in")
        }
        // console.log("months: ", months, "membershipCount: ", membershipCount, "subscriptionCount: ", subscriptionCount)

    }, [dashboardData]);


    const months = dashboardData?.graph_data?.memberships?.months;
    const membershipCount = dashboardData?.graph_data?.memberships?.counts;
    const subscriptionCount = dashboardData?.graph_data?.subscriptions?.counts;
    const doorstepCount = dashboardData?.graph_data?.doorstepOrders?.counts;


    const memberhsipAndSubsChartData = {
        labels: months?.map((data) => data),
        datasets: [
            {
                label: "Membership Sales",
                data: membershipCount?.map((data) => data),
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                    'rgba(255, 205, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(201, 203, 207, 0.2)',
                    'rgba(133, 0, 39, 0.2)',
                    'rgba(149, 149, 149, 0.2)',
                    'rgba(0, 138, 138, 0.2)',
                    'rgba(10, 0, 0, 0.2)',
                    'rgba(149, 164, 164, 0.2)',
                ],
                borderColor: [
                    'rgb(255, 99, 132)',
                    'rgb(255, 159, 64)',
                    'rgb(255, 205, 86)',
                    'rgb(75, 192, 192)',
                    'rgb(54, 162, 235)',
                    'rgb(153, 102, 255)',
                    'rgb(201, 203, 207)',
                    'rgba(133, 0, 39)',
                    'rgba(149, 149, 149)',
                    'rgba(0, 138, 138)',
                    'rgba(10, 0, 0)',
                    'rgba(149, 164, 164)'
                ],
                borderWidth: 2
            },
            {
                label: "Subscription Sales",
                data: subscriptionCount?.map((data) => data),
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                    'rgba(255, 205, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(201, 203, 207, 0.2)',
                    'rgba(133, 0, 39, 0.2)',
                    'rgba(149, 149, 149, 0.2)',
                    'rgba(0, 138, 138, 0.2)',
                    'rgba(10, 0, 0, 0.2)',
                    'rgba(149, 164, 164, 0.2)',
                ],
                borderColor: [
                    'rgb(255, 99, 132)',
                    'rgb(255, 159, 64)',
                    'rgb(255, 205, 86)',
                    'rgb(75, 192, 192)',
                    'rgb(54, 162, 235)',
                    'rgb(153, 102, 255)',
                    'rgb(201, 203, 207)',
                    'rgba(133, 0, 39)',
                    'rgba(149, 149, 149)',
                    'rgba(0, 138, 138)',
                    'rgba(10, 0, 0)',
                    'rgba(149, 164, 164)'
                ],
                borderWidth: 2
            }
        ]
    }


    const subscriptionChartData = {
        labels: months?.map((data) => data),
        datasets: [
            {
                label: "Subscription Sales",
                data: subscriptionCount?.map((data) => data),
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                    'rgba(255, 205, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(201, 203, 207, 0.2)',
                    'rgba(133, 0, 39, 0.2)',
                    'rgba(149, 149, 149, 0.2)',
                    'rgba(0, 138, 138, 0.2)',
                    'rgba(10, 0, 0, 0.2)',
                    'rgba(149, 164, 164, 0.2)',
                ],
                borderColor: [
                    'rgb(255, 99, 132)',
                    'rgb(255, 159, 64)',
                    'rgb(255, 205, 86)',
                    'rgb(75, 192, 192)',
                    'rgb(54, 162, 235)',
                    'rgb(153, 102, 255)',
                    'rgb(201, 203, 207)',
                    'rgba(133, 0, 39)',
                    'rgba(149, 149, 149)',
                    'rgba(0, 138, 138)',
                    'rgba(10, 0, 0)',
                    'rgba(149, 164, 164)'
                ],
                borderWidth: 1
            }
        ]
    }
    const doorstepChartData = {
        labels: months?.map((data) => data),
        datasets: [
            {
                label: "Order Sales",
                data: doorstepCount?.map((data) => data),
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                    'rgba(255, 205, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(201, 203, 207, 0.2)',
                    'rgba(133, 0, 39, 0.2)',
                    'rgba(149, 149, 149, 0.2)',
                    'rgba(0, 138, 138, 0.2)',
                    'rgba(10, 0, 0, 0.2)',
                    'rgba(149, 164, 164, 0.2)',
                ],
                borderColor: [
                    'rgb(255, 99, 132)',
                    'rgb(255, 159, 64)',
                    'rgb(255, 205, 86)',
                    'rgb(75, 192, 192)',
                    'rgb(54, 162, 235)',
                    'rgb(153, 102, 255)',
                    'rgb(201, 203, 207)',
                    'rgba(133, 0, 39)',
                    'rgba(149, 149, 149)',
                    'rgba(0, 138, 138)',
                    'rgba(10, 0, 0)',
                    'rgba(149, 164, 164)'
                ],
                borderWidth: 2
            }
        ]
    }

    const firstRow: IFristRow[] = [
        {
            // no: 2,
            icon: workers1,
            title: "Today's Worker",
            totalValues: dashboardData?.todayWorkersCount as number,
            active: dashboardData?.todayActivatedWorkers as number,
            inActive: dashboardData?.todayInactiveWorkers as number,
            bg: "bg-secondary-transparent",
            sideBg: "bg-secondary",
            bottomText: "then yesterday",
            bottomPercent: dashboardData?.dayPercentageChangeInWorker as number,
            link: "/workers"
        },
        {
            // no: 3,
            icon: users1,
            title: "Today's Users",
            totalValues: dashboardData?.todayUsersCount as number,
            active: dashboardData?.todayVerifiedUsers as number,
            inActive: dashboardData?.todayNotVerifiedUsers as number,
            bg: "bg-warning-transparent",
            sideBg: "bg-warning",
            bottomText: "then yesterday",
            bottomPercent: dashboardData?.dayPercentageChangeInUsers as number,
            link: "/users"
        },
        {
            // no: 1,
            icon: workers,
            title: "Total Workers",
            totalValues: dashboardData?.totalWorkerCount as number,
            active: dashboardData?.totalActivatedWorkers as number,
            inActive: dashboardData?.totalInactiveWorkers as number,
            bg: "bg-danger-transparent",
            sideBg: "bg-danger",
            bottomText: "then last week",
            bottomPercent: dashboardData?.weekPercentageChangeInWorker as number,
            link: "/workers"

        },
        {
            // no: 4,
            icon: customers,
            title: "Total Users",
            totalValues: dashboardData?.totalUsersCount as number,
            active: dashboardData?.totalVerifiedUsers as number,
            inActive: dashboardData?.totalNotVerifiedUsers as number,
            bg: "bg-success-transparent",
            sideBg: "bg-success",
            bottomText: "then last week",
            bottomPercent: dashboardData?.weekPercentageChangeInUsers as number,
            link: "/users"
        },
    ]

    return (
        <MainLayout>

            <main className="main-content position-relative max-height-vh-100 h-100 w-100 border-radius-lg " >

                <div className="container-fluid py-4">
                    <div className="row">
                        {
                            firstRow?.map((data, i) => (
                                <Link to={data?.link} key={i} className="col-xxl-3 col-sm-6 d-flex" style={{ color: "#7b809a", cursor: "pointer" }}>

                                    <div className="card flex-fill animate-card border-0">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className={`avatar avatar-xl me-2 p-1 ${data?.bg}`}>
                                                    <img src={data?.icon} alt="" />
                                                </div>
                                                <div className="overflow-hidden flex-fill">
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <h4 className="counter">{data?.totalValues}</h4>
                                                        <span className={`badge ${data?.sideBg}`}>1.2%</span>
                                                    </div>
                                                    <p className="text-start">{data?.title}</p>

                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                                                <div className="d-flex">
                                                    <p className="mb-0 border-bottom">
                                                    Active :

                                                    </p>
                                                    <span className="d-flex align-items-center text-dark fw-semibold ps-2" style={{ fontWeight: "600" }}>
                                                        {data?.active}
                                                    </span>
                                                </div>
                                                <div className="d-flex">
                                                    <p className="mb-0 border-bottom">
                                                    Inactive :

                                                    </p>
                                                    <span className="d-flex align-items-center text-dark fw-semibold ps-2" style={{ fontWeight: "600" }}>
                                                        {data?.inActive}
                                                    </span>
                                                </div>

                                            </div>
                                            <hr className="dark horizontal my-0 mb-1" />
                                            <div className="card-footer p-1">
                                                <p className="mb-0">
                                                    <span className={` ${data?.bottomPercent as number > 0 ? "text-success" : "text-danger"} text-sm font-weight-bolder`}>
                                                        {data?.bottomPercent as number > 0 ? "+" : ""} {data?.bottomPercent}% </span>{data?.bottomText} </p>
                                            </div>
                                        </div>
                                    </div>

                                </Link>
                            ))
                        }


                    </div>
                    <div className="row mt-4">
                        <div className=" col-md-6 mt-4 mb-4">
                            <div className="card z-index-2 ">
                                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2 bg-transparent">
                                    <div className="bg-white shadow-dark border-radius-lg py-3 pe-1">
                                        <div className="chart">
                                            <BarChart chartData={memberhsipAndSubsChartData} display={true} text={`Membership and Subscription Sales between ${new Date().getFullYear()} to ${new Date().getFullYear() + 1}`} />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <h6 className="mb-0 ">Membership Sales</h6>
                                    <p className="text-sm "> (<span className="font-weight-bolder">{`${dashboardData?.monthPercentageChangeInMembership}%`}</span>) increase in this month's sales. </p>
                                    {/* <hr className="dark horizontal" />
                                    <div className="d-flex ">
                                        <i className="material-icons text-sm my-auto me-1">schedule</i>
                                        <p className="mb-0 text-sm"> campaign sent 2 days ago </p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        {/* <div className=" col-md-6 mt-4 mb-4">
                            <div className="card z-index-2  ">
                                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2 bg-transparent">
                                    <div className="bg-white shadow-success border-radius-lg py-3 pe-1">
                                        <div className="chart">
                                            <BarChart chartData={subscriptionChartData} text={`Subscription Sales between ${new Date().getFullYear()} to ${new Date().getFullYear() + 1}`} />

                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <h6 className="mb-0 "> Subscription sales </h6>
                                    <p className="text-sm "> (<span className="font-weight-bolder">{`${dashboardData?.monthPercentageChangeInSubscription}%`}</span>) increase in this month's sales. </p>

                                </div>
                            </div>
                        </div> */}
                        <div className="col-md-6 mt-4 mb-3">
                            <div className="card z-index-2 ">
                                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2 bg-transparent">
                                    <div className="bg-white shadow-dark border-radius-lg py-3 pe-1">
                                        <div className="chart">
                                            {/* <canvas id="chart-line-tasks" className="chart-canvas" height="170"></canvas> */}
                                            <BarChart chartData={doorstepChartData} display={false} text={`Doorstep Orders between ${new Date().getFullYear()} to ${new Date().getFullYear() + 1}`} />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <h6 className="mb-0 ">Total Doorstep Orders</h6>
                                    <p className="text-sm "> (<span className="font-weight-bolder">{`${dashboardData?.monthPercentageChangeInDoorstepOrders}%`}</span>) increase in this month's sales. </p>
                                    {/* <hr className="dark horizontal" />
                                    <div className="d-flex ">
                                        <i className="material-icons text-sm my-auto me-1">schedule</i>
                                        <p className="mb-0 text-sm">just updated</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>

                    </div>


                </div>

                {/* Core JS Files   */}
                <script src="../../assets/js/core/popper.min.js" />
                <script src="../../assets/js/core/bootstrap.min.js" />
                <script src="../../assets/js/plugins/perfect-scrollbar.min.js" />
                <script src="../../assets/js/plugins/smooth-scrollbar.min.js" />
                <script src="../../assets/js/plugins/chartjs.min.js" />
                <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900|Roboto+Slab:400,700" />
                {/* <!-- Nucleo Icons --> */}
                <link href="../../assets/css/nucleo-icons.css" rel="stylesheet" />
                <link href="../../assets/css/nucleo-svg.css" rel="stylesheet" />
                {/* <!-- Font Awesome Icons --> */}
                <script src="https://kit.fontawesome.com/42d5adcbca.js" />
                {/* <!-- Material Icons --> */}
                <link href="https://fonts.googleapis.com/icon?family=Material+Icons+Round" rel="stylesheet" />
                {/* <!-- CSS Files --> */}
                <link id="pagestyle" href="../../assets/css/material-dashboard.css?v=3.1.0" rel="stylesheet" />
            </main>
        </MainLayout>


    )
}

export default DashboardPage;